// extracted by mini-css-extract-plugin
export default {"goto":"GoToTheWeb_goto__4MuQi","container":"GoToTheWeb_container__lAwZc"};